module.exports = __webpack_public_path__ + "static/media/10.8390b1ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SectionTwo/expos/10.png
// module id = 181
// module chunks = 0